require('./bootstrap');

import Vue from 'vue'
import VueMeta from 'vue-meta'
import {InertiaProgress} from '@inertiajs/progress'
import VueSweetalert2 from 'vue-sweetalert2';
import VueGoodTablePlugin from 'vue-good-table';
import vSelect from 'vue-select'
import {Vuelidate} from 'vuelidate';
import DatePicker from 'vue2-datepicker'
import JsonCSV from 'vue-json-csv';

import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-select/dist/vue-select.css';
import 'vue-good-table/dist/vue-good-table.css'
import 'vue2-datepicker/index.css';
import {createInertiaApp} from "@inertiajs/inertia-vue";
// import Echo from "laravel-echo";


Vue.mixin({methods: {route: window.route}})
Vue.use(VueMeta)
Vue.use(VueSweetalert2);
Vue.use(DatePicker);
Vue.use(Vuelidate);
Vue.use(VueGoodTablePlugin);
Vue.component('downloadCsv', JsonCSV);
vSelect.props.components.default = () => ({
    Deselect: {
        render: createElement => createElement('span', 'x'),
    },
    // OpenIndicator: {
    //     render: createElement => createElement('span', '🔽'),
    // },
});
Vue.component('v-select', vSelect)

window.axios = require('axios');

// window.Pusher = require('pusher-js');

// window.pushr = new Pusher('46c9e9791e055853e77f', {
//     wsHost: 'localhost',
//     wsPort: 6001,
//     forceTLS: false,
//     disableStats: true,
//     enabledTransports: ['ws', 'wss']
// });

// window.echo = new Echo({
//     broadcaster: 'pusher',
//     key: '46c9e9791e055853e77f',
//     wsHost: 'roja-cab-backend.test',// '188.166.31.95',
//     wsPort: 6001,
//     forceTLS: false,
//     // encrypted: true,
//     disableStats: true,
//     // auth: {headers: {Authorization: 'Bearer sometoken'}},
//     authEndpoint: 'http://roja-cab-backend.test/broadcasting/auth',
// });

// window.echo = new Echo({
//     broadcaster: 'reverb',
//     key: process.env.MIX_REVERB_APP_KEY,
//     wsHost: 'temp-staging-admin.keru.app',
//     wsPort: process.env.MIX_REVERB_PORT || 80,
//     // wssPort: process.env.MIX_REVERB_SSL_PORT || 443,
//     forceTLS: true,
//     enabledTransports: ['ws', 'wss'],
//     // wsPath: '/app',
//     // encrypted: true,
//     // disableStats: true,
//     // authEndpoint: 'http://roja-cab-backend.test/broadcasting/auth',
// });

InertiaProgress.init()


createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({el, app, props}) {
        new Vue({
            metaInfo: {
                titleTemplate: title => (title ? `${title} | Keru` : 'Keru'),
            },
            render: h => h(app, props),
        }).$mount(el)
    },
});
